import { Controller } from "@hotwired/stimulus"

// Borrowed from https://github.com/stimulus-components/stimulus-scroll-to
// Connects to data-controller="scroll-to"
export default class extends Controller {
  static values = {
    offset: Number,
    behavior: String,
  }

  initialize() {
    this.scroll = this.scroll.bind(this)
  }

  connect() {
    this.element.addEventListener("click", this.scroll)
  }

  disconnect() {
    this.element.removeEventListener("click", this.scroll)
  }

  scroll(s) {
    s.preventDefault()
    const e = this.element.hash.replace(/^#/, ""),
      t = document.getElementById(e)
    if (!t) {
      console.warn(
        `[stimulus-scroll-to] The element with the id: "${e}" does not exist on the page.`
      )
      return
    }
    const o = t.getBoundingClientRect().top + window.pageYOffset - this.offset
    window.scrollTo({
      top: o,
      behavior: this.behavior,
    })
  }

  get offset() {
    return this.hasOffsetValue
      ? this.offsetValue
      : this.defaultOptions.offset !== void 0
      ? this.defaultOptions.offset
      : 10
  }

  get behavior() {
    return this.behaviorValue || this.defaultOptions.behavior || "smooth"
  }

  get defaultOptions() {
    return {}
  }
}
